import SignRequestSource from "./gen/qsign/types/SignRequestSource";

const labels = {
  [SignRequestSource.EXTERNAL]: "Externí systém",
  [SignRequestSource.MANUALLY]: "Ručně",
};

export function getCaption(source: SignRequestSource) {
  const caption = labels[source];
  return caption ? caption : "[" + source + "]";
}
